import styles from './ClientOrderList.module.css'
import ModalWindow from "../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import React, {useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {AddFeedBackInt} from "./ClientOrderList";
interface ClientOrderRecallPropsInt
{
    orderId:string
    author: string
    defPhone: string
    onClose:()=>void
}
export default function ClientOrderRecall({orderId,onClose,author,defPhone}:ClientOrderRecallPropsInt){
    const [phone, setPhone] = useState(defPhone)
    const appealErrorLine = useRef<ErrorLineItemRef>(null)

    const addFeedBackData = useRef<AddFeedBackInt>()
    const [ldrAddFeedback,rsAddFeedback,exAddFeedback] = useApiQuery("/appeal/add","post",addFeedBackData);


    const handleSendAppeal = () =>{
        if( ! phone?.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui))
        {
            if(appealErrorLine.current)appealErrorLine.current.show("Не корректный телефон",true,2000)
            return;
        }

        addFeedBackData.current = {
            type: 5,
            author:author,
            parent: 0,
            phone: phone,
            xData: orderId,
            text: `Прошу перезвонить по заказу [ ${orderId} ]`,
            capt:""
        }
        exAddFeedback().then((e)=>{
            if(e?.success)
            {
                if(appealErrorLine.current)appealErrorLine.current.show("Обращение отправлено", false,2000)
                setTimeout(()=>onClose(),2000)
                return
            }
            if(appealErrorLine.current)appealErrorLine.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000)
        }).catch((e)=>{
            if(appealErrorLine.current)appealErrorLine.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,2000)
        })


    }

    return(
        <ModalWindow onClose={() => onClose()}>
            <MainFormTemplate title={`Обратный звонок по заказу [ ${orderId} ]`} maxWidth={"400px"} background={"white"}>
                <div className={"row mt-3"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={phone }
                            mode={"ei"}
                            info={"Телефон для связи"}
                            title={"Телефон"}
                            titleShift={-1}
                            placeHolder={"Телефон"}
                            inputType={0}
                            regExp={/^((\+7)|(8)|(^))9[0-9]{9}$/ui}
                            onChange={(e)=>{
                                if(e?.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui))
                                {
                                    const rt = e?.match(/[0-9]{10}$/ui)
                                    if(rt) setPhone(`+7${rt[0]}`)
                                    return
                                }
                                setPhone(e)
                            }}
                        ></InputItem>
                    </div>

                </div>


                <div className={styles.errCont}>
                    <ErrorLineItem ref={appealErrorLine}></ErrorLineItem>
                </div>

                <div className={"row"}>
                    <div className={styles.actCont} >

                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>handleSendAppeal()}
                            >Отправить</button>
                        </div>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>onClose()}
                            >Закрыть</button>
                        </div>

                        <div className={styles.ldrCont} >
                            <WaitLoader loading={ldrAddFeedback} api={rsAddFeedback} onlyLoading={true}>

                            </WaitLoader>
                        </div>

                    </div>


                </div>

            </MainFormTemplate>

        </ModalWindow>
    )
}